export const FINANCING_ENDING_DELIVERY_POLLING_INTERVAL_MS = 30_000;
